var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.errors),function(error,index){return _c('div',{key:error,staticClass:"alert alert-danger",class:[("mb-" + (index + 1 === _vm.errors.length ? '0': '2'))]},[_vm._v(" "+_vm._s(error)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }